import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    variant: 'odds',
    fontSize: 'sm',
    fontWeight: 'bold',
    fontFamily: 'accent',
  },
  buttonBaseSpanProps: {
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontFamily: 'accent',
    fontSize: '3xs',
  },
  buttonBaseBox: {
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
  },
  textBase: {
    textAlign: 'center',
    color: 'beta.500',
  },
};
